import React from "react";
import { ImageState } from "./enum";

/**
 * Returns true if url is valid image url, otherwise false
 */
// TODO: TW Check file rename once image component is integrated.
export default function useImageURLStatusCheck(props: { imageLocation?: string }) {
  const [imageState, setImageState] = React.useState(ImageState.LOADING);

  React.useEffect(() => {
    const image = new Image();
    function handleLoad() {
      setImageState(ImageState.LOADED);
    }
    function handleError() {
      setImageState(ImageState.ERROR);
    }
    try {
      image.src = props.imageLocation || "";
      image.addEventListener("load", handleLoad);
      image.addEventListener("error", handleError);
    } catch (err) {
      setImageState(ImageState.ERROR);
    }
    return () => {
      image.removeEventListener("load", handleLoad);
      image.removeEventListener("error", handleError);
    };
  }, [props.imageLocation]);

  return {
    isLoading: imageState === ImageState.LOADING,
    isSuccess: imageState === ImageState.LOADED,
    isError: imageState === ImageState.ERROR
  };
}
